import { getApiBaseUrl } from "../config/apiBaseUrl";

export const API_BASE_URL = getApiBaseUrl();
